import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CloseButton } from '../../shared/svg/components';
import LogoutService from '../../services/LogoutService';
import { setPopupState } from '../../model/configuratorSlice';
import { PopupState } from '../../model/constants';
import { TranslationUtility } from '../../utilities/TranslationUtility';

const Logout = () => {
    const logoutMutation = LogoutService();
    const dispatch = useDispatch();

    const closePopupHandler = () => {
        dispatch(setPopupState(PopupState.None));
    };
    const logout = () => {
        logoutMutation.mutate();
        closePopupHandler();
        // dispatch(changeLogoutPopupOpened(false));
    };
    return (
      <div className="logout-popup opened">
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button
          className="background opened"
          type="button"
          // onClick={() => dispatch(changeLogoutPopupOpened(false))}
          onClick={() => closePopupHandler()}
        />
        <div className="background opened" />
        <div className="panel opened">
          <div className="header">
            {TranslationUtility.GetFormattedMessageForUI('ui-logout-panel-title', 'Cerrar Sesión')}
          </div>
          <div className="sub-header">
            {TranslationUtility.GetFormattedMessageForUI('ui-logout-panel-subtitle',
                  '¿Está seguro que desea cerrar la sesión?')}
          </div>
          <button
            className="close-button"
            type="button"
            // onClick={() => dispatch(changeLogoutPopupOpened(false))}
            onClick={() => closePopupHandler()}
          ><CloseButton />
          </button>
          <div className="container-buttons">
            <button
              className="logout-button"
              type="button"
              onClick={() => logout()}
            >
              <span>
                {TranslationUtility.GetFormattedMessageForUI('ui-logout-panel-button', 'Aceptar')}
              </span>
            </button>
          </div>
        </div>
      </div>
    );
};

export default Logout;
